<template>
  <b-modal
    id="modal-status-finish"
    :title="$t('maintenance.serviceToNormal')"
    size="lg"
    centered
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    no-close-on-route-change
    no-caret
  >
    <div>
      <span> {{ $t('maintenance.order.text.insertDateAndOdometer') }} </span>

      <div class="mt-2">
        <FormulateForm v-model="form">
          <b-row>
            <b-col
              :class="
                hasNoServiceSchedule
                  ? 'md-4'
                  : refrigeratorData == 0 || kilometerData == 0 || hourmeterData == 0
                  ? 'md-6'
                  : 'md-4'
              "
            >
              <div class="m-0 p-0">
                <FormulateInput
                  name="actualEndTime"
                  :label="$t('maintenance.order.actualEndTime')"
                  :placeholder="$t('maintenance.order.actualEndTime')"
                  type="date-picker"
                  datepickerType="datetime"
                  format="DD MMM YYYY - HH:mm"
                  value-type="YYYY-MM-DD HH:mm"
                  :showSecond="false"
                  :help="'required'"
                  validation="required"
                  validation-behavior="blur"
                  error-behavior="blur"
                />
              </div>
            </b-col>
            <b-col
              v-show="kilometerData || hasNoServiceSchedule"
              :class="hasNoServiceSchedule ? 'md-4' : hourmeterData == 0 ? 'md-6' : 'md-4'"
            >
              <div class="m-0 p-0">
                <FormulateInput
                  name="kilometerFleet"
                  :label="$t('maintenance.order.kilometerFleet')"
                  :placeholder="$t('maintenance.order.kilometerFleet')"
                  suffix
                  :help="'required'"
                  validation="required"
                  validation-behavior="blur"
                  error-behavior="blur"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.order.kilometerFleet') }} </label>
                      <span
                        v-b-tooltip.top
                        :title="`${$t('maintenance.order.kilometerFleet')} ${thousandFormat(
                          parseFloat(serviceOrder?.odometer)/1000
                        )}`"
                      >
                        <i class="icon-outline_info"></i>
                      </span>
                    </div>
                  </template>

                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('dashboard.object.km') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col
              v-show="hourmeterData || hasNoServiceSchedule"
              :class="hasNoServiceSchedule ? 'md-4' : kilometerData == 0 ? 'md-6' : 'md-4'"
            >
              <div class="m-0 p-0">
                <FormulateInput
                  name="hourmeterFleet"
                  :placeholder="$t('maintenance.order.hourmeterFleet')"
                  suffix
                  :help="'required'"
                  validation="required"
                  validation-behavior="blur"
                  error-behavior="blur"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.order.hourmeterFleet') }} </label>
                      <span
                        v-b-tooltip.top
                        :title="`${$t('maintenance.order.hourmeterFleet')} ${minuteToHour(
                          serviceOrder?.hourmeter
                        )}`"
                      >
                        <i class="icon-outline_info"></i>
                      </span>
                    </div>
                  </template>

                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('global.time.hour') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
            <b-col v-show="refrigeratorData && showRefrigerator" :class="kilometerData == 0 ? 'md-6' : 'md-4'">
              <div class="m-0 p-0">
                <FormulateInput
                  name="refrigeratorFleet"
                  :label="$t('maintenance.order.refrigeratorFleet')"
                  :placeholder="$t('maintenance.order.refrigeratorFleet')"
                  suffix
                  :help="'required'"
                  validation="required"
                  validation-behavior="blur"
                  error-behavior="blur"
                >
                  <template #label>
                    <div class="d-flex justify-content-between align-items-center">
                      <label>{{ $t('maintenance.order.refrigeratorFleet') }} </label>
                      <span
                        v-b-tooltip.top
                        :title="`${$t('maintenance.order.refrigeratorFleet')} ${minuteToHour(
                          serviceOrder?.refrigerator
                        )}`"
                      >
                        <i class="icon-outline_info"></i>
                      </span>
                    </div>
                  </template>

                  <template #suffix>
                    <div class="formulate-input-suffix">
                      <span>{{ $t('global.time.hour') }}</span>
                    </div>
                  </template>
                </FormulateInput>
              </div>
            </b-col>
          </b-row>
        </FormulateForm>
      </div>
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <div class="d-flex flex-row">
          <McButton
            class="me-2"
            icon="icon-fill_close"
            variant="secondary"
            :text="$t('global.action.cancel')"
            @click="handleCancel"
          />
          <McButton
            variant="primary"
            icon="icon-fill_checkmark"
            :text="$t('global.action.finish')"
            @click="handleFinish"
          />
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    McButton,
  },
  mixins: [Helper],

  props: ['serviceOrder', 'kilometerData', 'hourmeterData', 'refrigeratorData', 'showRefrigerator'],

  data() {
    return {
      form: {},
    }
  },

  computed: {
    hasNoServiceSchedule() {
      return !this.kilometerData && !this.hourmeterData && !this.refrigeratorData
    },
  },

  mounted() {
    if (this.serviceOrder) {
      this.form.kilometerFleet = this.serviceOrder?.odometer
        ? parseFloat(this.serviceOrder?.odometer / 1000).toFixed(2)
        : null
      this.form.hourmeterFleet = this.serviceOrder?.hourmeter
        ? parseFloat(this.serviceOrder?.hourmeter / 60).toFixed(2)
        : null
      this.form.refrigeratorFleet = this.serviceOrder?.refrigerator != null
        ? parseFloat(this.serviceOrder?.refrigerator / 60).toFixed(2)
        : null
    }
  },

  methods: {
    handleFinish() {
      this.$emit(
        'changeStatus',
        'Finished',
        this.form.actualEndTime,
        this.form.kilometerFleet,
        this.form.hourmeterFleet,
        this.form.refrigeratorFleet
      )
    },

    handleCancel() {
      this.$bvModal.hide('modal-status-finish')
      this.$emit('closeModal')
    },
  },
}
</script>
